import { AxiosError, AxiosResponse } from 'axios';

import { API_HANDLERS, GViewInfo } from 'api';
import { getAuthToken } from 'utils/getAuthToken';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useState } from 'react';

interface usePspGViewQueryOptions {
    projectId: string;
    queryOptions?: UseQueryOptions<AxiosResponse<GViewInfo>, AxiosError<any>>;
}

export function usePspGViewQuery({
    projectId,
    queryOptions = {},
}: usePspGViewQueryOptions) {
    // const projectId = 'prj16b6f1fe-5a95-47c1-8584-bfba666d844e';
    const [token] = useState(getAuthToken);

    const queryFn = () => 
        API_HANDLERS.PSP.GVIEW.GET({
            id: projectId as string,
            token: token || '',
        });

    return useQuery<AxiosResponse<GViewInfo>, AxiosError<any>>({
        queryKey: ['projectGView', projectId],
        queryFn,
        retry: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        ...queryOptions,
    });
}
